export const clone = <T>(data: T): T => JSON.parse(JSON.stringify(data));
export const isSame = <T>(a: T, b: T): boolean => JSON.stringify(a) === JSON.stringify(b);
